// Which app this bundle is. One codebase, two deployments, chosen by VITE_APP_TYPE:
//
//   PLATFORM  → https://madmin.tripza.in   (`npm run build:platform` → dist-platform, .env.platform)
//               Platform Console only, served from the domain root: /login, /dashboard, /tenants …
//   ERP       → https://erp.tripza.in      (`npm run build:erp` → dist-erp, .env.erp)
//               The tenant ERP only; no Platform Console route exists in it.
//   (unset)   → the combined app (`npm run dev`, `npm run build`): ERP at the root and the
//               Platform Console under /platform, exactly as before.
//
// VITE_APP_TYPE is replaced with a string literal at build time, so the routes of the other app are
// dead code and are dropped from the bundle — not hidden, absent. The API still enforces every role.
// Each flag reads import.meta.env directly: a comparison of two literals is what the bundler folds, and
// a comparison through a variable is not — the other app's pages then stayed in the bundle.

/** This bundle serves the Platform Console. */
export const SHOW_PLATFORM = import.meta.env.VITE_APP_TYPE !== 'ERP';

/** This bundle serves the tenant ERP. */
export const SHOW_ERP = import.meta.env.VITE_APP_TYPE !== 'PLATFORM';

/** The Platform Console is the whole app: its routes sit at the root, without the /platform prefix. */
export const PLATFORM_ONLY = import.meta.env.VITE_APP_TYPE === 'PLATFORM';

/**
 * The tenant ERP is the whole app (erp.tripza.in): no marketing landing page, and the address itself
 * ("/") is the sign-in page — /login forwards there.
 */
export const ERP_ONLY = import.meta.env.VITE_APP_TYPE === 'ERP';

/** Where the Platform Console's routes start: "" on madmin, "/platform" in the combined app. */
export const PLATFORM_BASE = PLATFORM_ONLY ? '' : '/platform';

/**
 * Where the Platform Console signs in. On madmin.tripza.in the address itself ("/") is the sign-in page;
 * in the combined app it stays /platform/login.
 */
export const PLATFORM_LOGIN_PATH = PLATFORM_ONLY ? '/' : '/platform/login';

/** A Platform Console path in this build, e.g. platformPath('/tenants') → "/tenants" or "/platform/tenants". */
export function platformPath(path: string): string {
  return `${PLATFORM_BASE}${path}`;
}
